/**
 * @generated SignedSource<<dd184d2bb8016a55283a51c72c89e350>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionConnectionDataTable_promotionConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly createdBy: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
      };
      readonly endAt: any;
      readonly id: string;
      readonly isRepeat: boolean;
      readonly priority: number;
      readonly sequence: number | null;
      readonly startAt: any;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"PromotionRepeatText_promotion" | "PromotionStatusLabel_promotion">;
    };
  }>;
  readonly " $fragmentType": "PromotionConnectionDataTable_promotionConnection";
};
export type PromotionConnectionDataTable_promotionConnection$key = {
  readonly " $data"?: PromotionConnectionDataTable_promotionConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionConnectionDataTable_promotionConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionConnectionDataTable_promotionConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Promotion",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PromotionStatusLabel_promotion"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priority",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRepeat",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PromotionRepeatText_promotion"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserAvatarText_user"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PromotionConnection",
  "abstractKey": null
};
})();

(node as any).hash = "6b3e382b51163086df9c31546e516fee";

export default node;
